import { ApolloClient, HttpLink, InMemoryCache, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

import { DOMAIN, PREVIEW_DOMAIN } from "@const/urls";

const KEYS = {
  ko: {
    uri: import.meta.env.VITE_KR_STOREFRONT_URI,
    token: import.meta.env.VITE_KR_STOREFRONT_ACCESS_TOKEN,
  },
  en: {
    uri: import.meta.env.VITE_INTL_STOREFRONT_URI,
    token: import.meta.env.VITE_INTL_STOREFRONT_ACCESS_TOKEN,
  },
  jp: {
    uri: import.meta.env.VITE_JP_STOREFRONT_URI,
    token: import.meta.env.VITE_JP_STOREFRONT_ACCESS_TOKEN,
  },
};

const lang = localStorage.getItem("i18nextLng");
let newLang = "ko";

if (window.location.href.includes("localhost") || window.location.hostname.includes("ngrok")) {
  newLang = lang ? lang : newLang;
} else {
  if (window.location.href.includes(DOMAIN.ko) || window.location.href.includes(PREVIEW_DOMAIN.ko)) {
    newLang = "ko";
  }

  if (window.location.href.includes(DOMAIN.en) || window.location.href.includes(PREVIEW_DOMAIN.en)) {
    newLang = "en";
  }

  if (window.location.href.includes(DOMAIN.jp) || window.location.href.includes(PREVIEW_DOMAIN.jp)) {
    newLang = "jp";
  }
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // GraphQL Error
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error("[APOLLO] GraphQL error", {
        message,
        location: JSON.stringify(locations),
        path: JSON.stringify(path),
      });
    });
  }

  // Network Error
  if (networkError) {
    console.error("[APOLLO] Network error", { networkError });
    throw new Error(`[APOLLO] Network error : ${JSON.stringify(networkError)}`);
  }
});

const authLink = setContext(() => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-shopify-Storefront-Access-Token": KEYS[newLang as keyof typeof KEYS].token,
    },
  };
});

const httpLink = new HttpLink({ uri: KEYS[newLang as keyof typeof KEYS].uri });

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Collection: {
        keyFields: ["handle"],
      },
      Filter: {
        keyFields: ["values"],
      },
    },
  }),
  link: from([authLink, errorLink, httpLink]),
});

export default client;
